import { render, staticRenderFns } from "./downloader.vue?vue&type=template&id=ce96c546"
import script from "./downloader.vue?vue&type=script&lang=js"
export * from "./downloader.vue?vue&type=script&lang=js"
import style0 from "./downloader.vue?vue&type=style&index=0&id=ce96c546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports